import { View, StyleSheet } from "react-native";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import { colors } from "../../../styles/design-system";

interface DisconnectServiceModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  serviceName: string;
  accountEmail: string;
  isLoading?: boolean;
}

export const DisconnectServiceModal = ({
  visible,
  onClose,
  onConfirm,
  serviceName,
  accountEmail,
  isLoading = false,
}: DisconnectServiceModalProps) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={false} style={styles.modal}>
      <View style={styles.container}>
        <CustomText text={`Disconnect ${serviceName}?`} useTranslationText={false} style={styles.title} />
        <CustomSpacing size="sm" />
        <CustomText
          text={`This will revoke Axio's access to your ${serviceName} account (${accountEmail}). Content you've already shared stays available, but you won't be able to pull new files until you reconnect.`}
          useTranslationText={false}
          style={styles.description}
        />
        <CustomSpacing size="xl" />
        <View style={styles.footer}>
          <CustomButton
            text="Cancel"
            onPress={onClose}
            useTranslationText={false}
            styleType="lightStroke"
            style={styles.button}
            disabled={isLoading}
          />
          <CustomButton
            text={isLoading ? "Disconnecting..." : "Disconnect"}
            onPress={onConfirm}
            useTranslationText={false}
            styleType="danger"
            style={[styles.button, styles.disconnectButton]}
            disabled={isLoading}
          />
        </View>
      </View>
    </CustomModal>
  );
};

const styles = StyleSheet.create({
  modal: {
    maxWidth: 540,
    borderRadius: 24,
    padding: 32,
  },
  container: {
    alignItems: "center",
  },
  title: {
    fontSize: 24,
    lineHeight: 32,
    fontWeight: "700",
    color: colors.grey[900],
    textAlign: "center",
  },
  description: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.grey[500],
    textAlign: "center",
  },
  footer: {
    flexDirection: "row",
    gap: 12,
    width: "100%",
  },
  button: {
    flex: 1,
    borderRadius: 12,
  },
  disconnectButton: {
    backgroundColor: "#F04438", // Matching the red in the image more closely
  },
});
